// (Normally these contants' names would end with "_ANALYTICS_SOURCE" but then the names would be
//  things like "SPACE_ANALYTICS_ANALYTICS_SOURCE" and that's not readable)
export const INSTANCE_ANALYTICS_EVENTS_SOURCE = 'instanceAnalytics';
export const INSTANCE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE = 'instanceAnalyticsPermissions';
export const PAGE_ANALYTICS_EVENTS_SOURCE = 'pageAnalytics';
export const SPACE_ANALYTICS_EVENTS_SOURCE = 'spaceAnalytics';
export const SPACE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE = 'spaceAnalyticsPermissions';
